import { Component, OnInit, Input, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MmIdentityService } from '../../services';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Router, ActivatedRoute } from '@angular/router';
import { onFormSubmit } from '../../../form';
import { LoginModel } from '../../definition';
import { idenityI18nKeys } from '../../identity-i18n-keys';
import { identityConstants } from 'mm-web-core/identity/identity-constants';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'mm-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit {

  form: FormGroup;
  constructor(
    fb: FormBuilder, private identityService: MmIdentityService,
    private messageService: NzMessageService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private translateService: TranslateService) {
    this.form = fb.group({
      "userName": fb.control(null, Validators.required),
      "password": fb.control(null, Validators.required)
    })
  }

  i18nKeys = idenityI18nKeys;

  ngOnInit(): void {
  }

  translate(key: string) {
    return this.translateService.get(`${identityConstants.transalationGroup}.${key}`);
  }

  @Input()
  formTitle: TemplateRef<any> | string;

  get formTitleIsTemplate() {
    return typeof this.formTitle !== "string";
  }

  async login() {

    onFormSubmit(this.form)
    if (this.form.invalid) return;
    var model = <LoginModel>{
      ...this.form.value
    }
    let result = await this.identityService.login(model).toPromise();
    let returnUrl = this.activatedRoute.snapshot.queryParams["returnUrl"];
    if (result.success) {
      if (!returnUrl) {
        this.router.navigateByUrl(returnUrl)
      }
      else {
        this.router.navigate([".."]);
      }
    }
    else {
      this.messageService.error(result.message);
    }
  }

  resolveKey(key: string) {
    return `${identityConstants.transalationGroup}.${key}`
  }


}
